import { CheckBadgeAlternateBold } from '@ha/icons';
import React from 'react';

import { useIntl } from 'ha/i18n';
import { makeStyles } from 'tss-react/mui';
import { Chip, Tooltip, units } from '@hbf/dsl';

const useStyles = makeStyles()({
  tooltip: {
    zIndex: 2,
  },
  badge: {
    position: 'absolute',
    bottom: units.rem(1),
  },
});

const UserCardVerifiedBadge: React.FC = () => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <Tooltip
      className={classes.tooltip}
      placement="top"
      leaveTouchDelay={5000}
      title={
        <div data-test-locator="Verified student badge tooltip">
          {T('user_card.verified_badge.tooltip')}
        </div>
      }
    >
      <div className={classes.badge} data-test-locator="Verified student badge">
        <Chip
          icon={<CheckBadgeAlternateBold />}
          label={T('user_card.verified_badge.title')}
          color="primary"
        />
      </div>
    </Tooltip>
  );
};

export { UserCardVerifiedBadge };
